import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/favorites/toggle.ts
import { Exception } from "@wbk/logger";
var toggleUserFavorite = (params) => __async(void 0, null, function* () {
  try {
    const res = yield fetchClient({
      url: `/user-favorites/toggle${params._id ? `/${params._id}` : ""}`,
      options: {
        method: "POST",
        body: JSON.stringify(__spreadProps(__spreadValues({}, params), {
          status: params._id ? "remove" : "create"
        }))
      }
    });
    return res.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "toggleUserFavoriteException"
    });
  }
});

export {
  toggleUserFavorite
};
//# sourceMappingURL=chunk-N7WOQ7B5.mjs.map